export const getOnline = (state) => state?.notifications.online;

export const getNotificationById = (state, id) => state.notifications.notifications[id];

export const getNotifications = (state) =>
  Object.values(state.notifications.notifications).sort((a, b) => a.createdAt - b.createdAt);
